export const VBabyColors = {
  primaryDefault: '#7B61FF',
  primaryDark: '#5D4DEB',
  primaryLight: '#A692F2',
  primaryExtraLight: '#D6CEFD',

  primary100: '#7B61FF',
  primary90: '#8971FF',
  primary80: '#9480FE',
  primary70: '#A290FE',
  primary60: '#AF9FFE',
  primary50: '#BBAEFE',
  primary40: '#C8BEFD',
  primary30: '#D6CEFD',
  primary20: '#E3DDFD',
  primary10: '#EFEDFC',

  secondaryDefault: '#F7F3F2',
  secondaryMedium: '#FDF7F1',
  secondaryDark: '#F9E8D6',
  secondaryLight: '#F7F3F2',
  tertiaryLight: '#FAF8F8',

  black: '#212121',
  gray90: '#383838',
  gray80: '#4C4C4C',
  gray70: '#636363',
  gray60: '#797979',
  gray50: '#8E8E8E',
  gray40: '#A4A4A4',
  gray30: '#BBBBBB',
  gray20: '#D1D1D1',
  gray10: '#E6E6E6',
  gray5: '#F1F1F1',

  grayLight: '#D2D2D2',
  grayMedium: '#A1A1A1',
  grayDark: '#737373',
  blackLight: '#484848',

  red: '#E20101',
  red50: '#EF7E7E',
  pink100: '#F59FE0',
  pink50: '#F8CDEE',
  yellow100: '#FEC551',
  yellow50: '#FDE0A6',
  white: '#FCFCFC',
  backgroundGrey: '#F4F4F4',

  gradientStart: '#DC8DDC',
  gradientMid: '#CBADEB',
  gradientEnd: '#CDF9E8',
}
